import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import anime from "animejs/lib/anime.es.js";
import { bookSoundPlayerState } from "@stores/popup";
import { useSetAtom } from "jotai";

const Button = styled.button`
  position: absolute;
  left: 145px;
  top: 195px;
  z-index: 10;
  width: 95px;
  height: 95px;
  background-color: var(--theme-color);
  border-radius: 50px;
  border: 8px solid #fff;
  background-size: 100%;
  box-shadow: 2px 2px 0px 2px rgba(0, 0, 0, 0.1);
  z-index: 20;
  opacity: 0;
  &.right {
    left: auto;
    right: 145px;
  }
  &:after {
    content: "";
    position: absolute;
    background: url(${require("@assets/img/icon_sound_play.png")}) no-repeat;
    background-size: 30px 30px;
    background-position: 29px center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: inline-block;
  }
`;

const BookSoundButton = ({ cName, data }) => {
  const buttonRef = useRef(null);
  const setSound = useSetAtom(bookSoundPlayerState);
  useEffect(() => {
    anime({
      delay: 400,
      targets: buttonRef.current,
      scale: [0, 1],
      opacity: [0, 1],
    });

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      anime.remove(buttonRef.current);
      setSound({
        open: false,
        url: "",
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return data && data.sound ? (
    <div className="book-sound-button">
      <Button
        ref={buttonRef}
        className={cName && cName}
        type="button"
        onClick={() => {
          setSound({
            open: true,
            url: data.sound,
          });
        }}
      />
    </div>
  ) : null;
};

export default React.memo(BookSoundButton);
